import styled from 'styled-components';

export const CenterContainer = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 600px;
    margin: 0 auto;

    > h1 {
        margin-bottom: 0;
    }
`;
